// src/api/university.js
import apiClient from './client';

export const getMyUniversity = () => apiClient.get('/universities/me');

export const listUniversities = () => apiClient.get('/universities');

export const updateUniversity = (id, data) =>
  apiClient.put(`/universities/${id}`, data);

export const uploadUniversityLogo = (id, formData) =>
  apiClient.post(`/universities/${id}/logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

const universityAPI = {
  getMyUniversity,
  listUniversities,
  updateUniversity,
  uploadLogo: uploadUniversityLogo
};

export default universityAPI;
